export class EditorNode {
  constructor(node) {
    this.node = node;
  }

  isText() {
    return this.node.nodeType === Node.TEXT_NODE;
  }

  isElement() {
    return this.node.nodeType === Node.ELEMENT_NODE;
  }

  isBlock() {
    if (!this.isElement()) return false;
    const el = this.node;
    const blockTags = [
      "P",
      "DIV",
      "LI",
      "UL",
      "OL",
      "H1",
      "H2",
      "H3",
      "H4",
      "H5",
      "H6",
      "BLOCKQUOTE",
    ];
    return blockTags.includes(el.tagName);
  }

  isInline() {
    if (!this.isElement()) return false;
    const el = this.node;
    const inlineTags = ["SPAN", "B", "STRONG", "I", "EM", "A", "U"];
    return inlineTags.includes(el.tagName);
  }

  unwrap() {
    if (!this.node.parentNode) return;
    while (this.node.firstChild) {
      this.node.parentNode.insertBefore(this.node.firstChild, this.node);
    }
    this.node.parentNode.removeChild(this.node);
  }

  remove() {
    this.node.parentNode?.removeChild(this.node);
  }

  wrap(wrapper) {
    const parent = this.node.parentNode;
    if (!parent) return;
    parent.insertBefore(wrapper, this.node);
    wrapper.appendChild(this.node);
  }

  static create(tag, text) {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    return el;
  }

  static getParentOuter(node, root) {
    let current = node;

    while (current && current.parentElement) {
      if (current.parentElement === root) {
        return current;
      }
      current = current.parentElement;
    }

    return null;
  }
}
